import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as o } from "../interface.js";
import a from "../../../checkbox/src/Checkbox.js";
import { defineComponent as n, inject as i, h as c } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const b = n({
  name: "DataTableBodyCheckbox",
  props: {
    rowKey: {
      type: [String, Number],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !0
    },
    onUpdateChecked: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedCheckedRowKeySetRef: r,
      mergedInderminateRowKeySetRef: d
    } = i(o);
    return () => {
      const {
        rowKey: t
      } = e;
      return c(a, {
        privateInsideTable: !0,
        disabled: e.disabled,
        indeterminate: d.value.has(t),
        checked: r.value.has(t),
        onUpdateChecked: e.onUpdateChecked
      });
    };
  }
});
export {
  b as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/BodyCheckbox.js
// module id = 1609
// module chunks = 41